var map = {
	"./EN/AdminPanel": "./src/Translation/EN/AdminPanel.json",
	"./EN/AdminPanel.json": "./src/Translation/EN/AdminPanel.json",
	"./EN/App": "./src/Translation/EN/App.json",
	"./EN/App.json": "./src/Translation/EN/App.json",
	"./EN/Auth": "./src/Translation/EN/Auth.json",
	"./EN/Auth.json": "./src/Translation/EN/Auth.json",
	"./EN/Common": "./src/Translation/EN/Common.json",
	"./EN/Common.json": "./src/Translation/EN/Common.json",
	"./EN/Company": "./src/Translation/EN/Company.json",
	"./EN/Company.json": "./src/Translation/EN/Company.json",
	"./EN/Dashboard": "./src/Translation/EN/Dashboard.json",
	"./EN/Dashboard.json": "./src/Translation/EN/Dashboard.json",
	"./EN/Demo": "./src/Translation/EN/Demo.json",
	"./EN/Demo.json": "./src/Translation/EN/Demo.json",
	"./EN/DevPanel": "./src/Translation/EN/DevPanel.json",
	"./EN/DevPanel.json": "./src/Translation/EN/DevPanel.json",
	"./EN/FirstConfig": "./src/Translation/EN/FirstConfig.json",
	"./EN/FirstConfig.json": "./src/Translation/EN/FirstConfig.json",
	"./EN/Footer": "./src/Translation/EN/Footer.json",
	"./EN/Footer.json": "./src/Translation/EN/Footer.json",
	"./EN/Invoices": "./src/Translation/EN/Invoices.json",
	"./EN/Invoices.json": "./src/Translation/EN/Invoices.json",
	"./EN/Orders": "./src/Translation/EN/Orders.json",
	"./EN/Orders.json": "./src/Translation/EN/Orders.json",
	"./EN/Profile": "./src/Translation/EN/Profile.json",
	"./EN/Profile.json": "./src/Translation/EN/Profile.json",
	"./EN/Programs": "./src/Translation/EN/Programs.json",
	"./EN/Programs.json": "./src/Translation/EN/Programs.json",
	"./EN/Projects": "./src/Translation/EN/Projects.json",
	"./EN/Projects.json": "./src/Translation/EN/Projects.json",
	"./EN/Quotes": "./src/Translation/EN/Quotes.json",
	"./EN/Quotes.json": "./src/Translation/EN/Quotes.json",
	"./EN/Security": "./src/Translation/EN/Security.json",
	"./EN/Security.json": "./src/Translation/EN/Security.json",
	"./EN/Sidebar": "./src/Translation/EN/Sidebar.json",
	"./EN/Sidebar.json": "./src/Translation/EN/Sidebar.json",
	"./EN/Tickets": "./src/Translation/EN/Tickets.json",
	"./EN/Tickets.json": "./src/Translation/EN/Tickets.json",
	"./ES/AdminPanel": "./src/Translation/ES/AdminPanel.json",
	"./ES/AdminPanel.json": "./src/Translation/ES/AdminPanel.json",
	"./ES/App": "./src/Translation/ES/App.json",
	"./ES/App.json": "./src/Translation/ES/App.json",
	"./ES/Auth": "./src/Translation/ES/Auth.json",
	"./ES/Auth.json": "./src/Translation/ES/Auth.json",
	"./ES/Common": "./src/Translation/ES/Common.json",
	"./ES/Common.json": "./src/Translation/ES/Common.json",
	"./ES/Company": "./src/Translation/ES/Company.json",
	"./ES/Company.json": "./src/Translation/ES/Company.json",
	"./ES/Dashboard": "./src/Translation/ES/Dashboard.json",
	"./ES/Dashboard.json": "./src/Translation/ES/Dashboard.json",
	"./ES/Demo": "./src/Translation/ES/Demo.json",
	"./ES/Demo.json": "./src/Translation/ES/Demo.json",
	"./ES/DevPanel": "./src/Translation/ES/DevPanel.json",
	"./ES/DevPanel.json": "./src/Translation/ES/DevPanel.json",
	"./ES/FirstConfig": "./src/Translation/ES/FirstConfig.json",
	"./ES/FirstConfig.json": "./src/Translation/ES/FirstConfig.json",
	"./ES/Footer": "./src/Translation/ES/Footer.json",
	"./ES/Footer.json": "./src/Translation/ES/Footer.json",
	"./ES/Invoices": "./src/Translation/ES/Invoices.json",
	"./ES/Invoices.json": "./src/Translation/ES/Invoices.json",
	"./ES/Orders": "./src/Translation/ES/Orders.json",
	"./ES/Orders.json": "./src/Translation/ES/Orders.json",
	"./ES/Profile": "./src/Translation/ES/Profile.json",
	"./ES/Profile.json": "./src/Translation/ES/Profile.json",
	"./ES/Programs": "./src/Translation/ES/Programs.json",
	"./ES/Programs.json": "./src/Translation/ES/Programs.json",
	"./ES/Projects": "./src/Translation/ES/Projects.json",
	"./ES/Projects.json": "./src/Translation/ES/Projects.json",
	"./ES/Quotes": "./src/Translation/ES/Quotes.json",
	"./ES/Quotes.json": "./src/Translation/ES/Quotes.json",
	"./ES/Security": "./src/Translation/ES/Security.json",
	"./ES/Security.json": "./src/Translation/ES/Security.json",
	"./ES/Sidebar": "./src/Translation/ES/Sidebar.json",
	"./ES/Sidebar.json": "./src/Translation/ES/Sidebar.json",
	"./ES/Tickets": "./src/Translation/ES/Tickets.json",
	"./ES/Tickets.json": "./src/Translation/ES/Tickets.json",
	"./FR/AdminPanel": "./src/Translation/FR/AdminPanel.json",
	"./FR/AdminPanel.json": "./src/Translation/FR/AdminPanel.json",
	"./FR/App": "./src/Translation/FR/App.json",
	"./FR/App.json": "./src/Translation/FR/App.json",
	"./FR/Auth": "./src/Translation/FR/Auth.json",
	"./FR/Auth.json": "./src/Translation/FR/Auth.json",
	"./FR/Common": "./src/Translation/FR/Common.json",
	"./FR/Common.json": "./src/Translation/FR/Common.json",
	"./FR/Company": "./src/Translation/FR/Company.json",
	"./FR/Company.json": "./src/Translation/FR/Company.json",
	"./FR/Dashboard": "./src/Translation/FR/Dashboard.json",
	"./FR/Dashboard.json": "./src/Translation/FR/Dashboard.json",
	"./FR/Demo": "./src/Translation/FR/Demo.json",
	"./FR/Demo.json": "./src/Translation/FR/Demo.json",
	"./FR/DevPanel": "./src/Translation/FR/DevPanel.json",
	"./FR/DevPanel.json": "./src/Translation/FR/DevPanel.json",
	"./FR/FirstConfig": "./src/Translation/FR/FirstConfig.json",
	"./FR/FirstConfig.json": "./src/Translation/FR/FirstConfig.json",
	"./FR/Footer": "./src/Translation/FR/Footer.json",
	"./FR/Footer.json": "./src/Translation/FR/Footer.json",
	"./FR/Invoices": "./src/Translation/FR/Invoices.json",
	"./FR/Invoices.json": "./src/Translation/FR/Invoices.json",
	"./FR/Orders": "./src/Translation/FR/Orders.json",
	"./FR/Orders.json": "./src/Translation/FR/Orders.json",
	"./FR/Profile": "./src/Translation/FR/Profile.json",
	"./FR/Profile.json": "./src/Translation/FR/Profile.json",
	"./FR/Programs": "./src/Translation/FR/Programs.json",
	"./FR/Programs.json": "./src/Translation/FR/Programs.json",
	"./FR/Projects": "./src/Translation/FR/Projects.json",
	"./FR/Projects.json": "./src/Translation/FR/Projects.json",
	"./FR/Quotes": "./src/Translation/FR/Quotes.json",
	"./FR/Quotes.json": "./src/Translation/FR/Quotes.json",
	"./FR/Security": "./src/Translation/FR/Security.json",
	"./FR/Security.json": "./src/Translation/FR/Security.json",
	"./FR/Sidebar": "./src/Translation/FR/Sidebar.json",
	"./FR/Sidebar.json": "./src/Translation/FR/Sidebar.json",
	"./FR/Tickets": "./src/Translation/FR/Tickets.json",
	"./FR/Tickets.json": "./src/Translation/FR/Tickets.json",
	"./translations_lang": "./src/Translation/translations_lang.json",
	"./translations_lang.json": "./src/Translation/translations_lang.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Translation sync recursive ^\\.\\/.*$";